import { render } from "./BetAmountChart.vue?vue&type=template&id=d3894cf4"
import script from "./BetAmountChart.vue?vue&type=script&lang=js"
export * from "./BetAmountChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/p878kMc7/0/softbot/pplotto/pplotto-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__